import Async from "react-select/lib/Async";
import React, {Component} from 'react';
import {parseResponse} from '../../utilities/Utility';
import query from 'svc/query';


class ReactSelectAsyncContainer extends Component {
	render() {
		const {typeName, value, focus} = this.props;
		return (
			<Async
				name={typeName}
				loadOptions={this.getOptions}
				onChange={this.onChange}
				autoFocus={focus}
				autoBlur={true}
				cache={false}
				value={value}
				placeholder={this.placeholderIfExits()}
				filterOptions={this.getFilterOptions()}
				className={this.className()}
			/>
		);
	}

	className = () => {
		const {disabled} = this.props;
		if (disabled === true) {
			return 'pt-disabled'
		}
	}

	placeholderIfExits = () => {
		return this.props.hasOwnProperty('placeholder') ? this.props.placeholder : 'Select...'
	}

	getFilterOptions = () => {
		if (this.props.querySearch === true) {
			return (options, filter, currentValues) => {
				return options;
			}
		} else {
			return null;
		}
	}

	onChange = (input) => {
		const {onChange, returnObj} = this.props;
		const addNewOptionFn = this.addNewOptionFn();
		if (input === null) {
			return null;
		}
		if (addNewOptionFn && input.value === 'addNew') {
			return addNewOptionFn();
		}
		onChange(input, returnObj);
	}

	getOptions = (input) => {
		const {queryName, minimumAttributeLength} = this.props;
		if (input.length < minimumAttributeLength) {
			return Promise.resolve([]);
		}
		const params = this.getParams(input);
		let q = query(queryName, {Params: params});
		return q.then(this.parseAutomatResponse);
	};

	getParams = (input) => {
		const {attr} = this.props;
		const baseParams = {
			[attr]: input
		};
		if (this.props.hasOwnProperty('defaultParams')) {
			return Object.assign({}, baseParams, this.props.defaultParams);
		}
		return baseParams;
	}

	parseAutomatResponse = (res) => {
		const values = parseResponse(res);
		const hasNewOption = this.addNewOptionFn();
		if (hasNewOption) {
			values.push({
				'value': 'addNew',
				'label': 'Add New'
			})
		}
		return {options: values};
	};

	addNewOptionFn = () => {
		return this.props.hasOwnProperty('addNewOptionFn') ? this.props.addNewOptionFn : false;
	};
}

ReactSelectAsyncContainer.defaultProps = {
	className: '',
	disabled: false
}

export default ReactSelectAsyncContainer;


// WEBPACK FOOTER //
// ./src/components/reactSelectWrappers/ReactSelectAsyncContainer.js